import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useSession } from '@/hooks/useSession';

function AdminGateState({ message }: { message: string }): React.ReactElement {
  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  );
}

export function RequireAdmin({ children }: { children: ReactNode }): React.ReactElement {
  const { status, isAdmin } = useSession();

  if (status === 'loading') {
    return <AdminGateState message="Loading admin access…" />;
  }

  if (status === 'error') {
    return (
      <AdminGateState message="Could not verify admin access. Check the server and refresh to try again." />
    );
  }

  if (status !== 'authenticated' || !isAdmin) {
    return <Navigate to="/chat" replace />;
  }

  return <>{children}</>;
}
